import * as React from "react";
import type { SVGProps } from "react";
const SvgLock04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.6 9.056V7.86C6.6 4.836 9.009 2.4 12 2.4s5.4 2.436 5.4 5.461v1.792M12 15.685v-2.4m7.2 1.147c0 3.959-3.224 7.168-7.2 7.168s-7.2-3.21-7.2-7.168S8.024 7.264 12 7.264s7.2 3.21 7.2 7.168Z"
    />
  </svg>
);
export default SvgLock04;
